export const SET_LOADING = 'SET_LOADING'
export const SET_PAYMENT_STATE_VALUE = 'SET_PAYMENT_STATE_VALUE'
export const SET_PRICE_RESPONSE = 'SET_PRICE_RESPONSE'
